import { Trie } from './trie';

export class KeyedTrie {
  private tries: Map<string, Trie>;

  constructor() {
    this.tries = new Map();
  }

  private getOrCreateTrie(key: string): Trie {
    let trie = this.tries.get(key);
    if (!trie) {
      trie = new Trie();
      this.tries.set(key, trie);
    }
    return trie;
  }

  /**
   * Insert a word that belongs to a specific key.
   * Example: keyedTrie.insert("key1", "apple")
   */
  insert(key: string, word: string): void {
    const trie = this.getOrCreateTrie(key);
    trie.insert(word);
  }

  /**
   * Construct a trie for a specific key with a list of words.
   * @param key
   * @param words
   */
  construct(key: string, words: string[]): void {
    const trie = this.getOrCreateTrie(key);
    trie.construct(words);
  }

  /**
   * Check if the given key contains a specific word.
   */
  contains(key: string, word: string): boolean {
    const trie = this.tries.get(key);
    if (!trie) return false;
    return trie.contains(word);
  }

  /**
   * Autocomplete within a specific key.
   * Example: keyedTrie.autocomplete("key1", "ap") -> ["apple", ...]
   */
  autocomplete(key: string, prefix: string, limit = Infinity): string[] {
    const trie = this.tries.get(key);
    if (!trie) return [];
    return trie.autocomplete(prefix, limit);
  }

  /**
   * (Optional) Get all keys you currently have tries for.
   */
  keys(): string[] {
    return Array.from(this.tries.keys());
  }
}
